import { createSelector } from 'reselect';
import { getImage } from '@utils';
import photoPlaceholder from '@images/image-not-available.png';

export const getUser = createSelector(({ user }) => user.user, result => result);
export const getLoadingState = createSelector(({ user }) => user.loading, result => result);
export const getUserName = createSelector(getUser, getLoadingState, (user, loading) => {
  if (loading) return null;
  return `${user?.MemberFirstName} ${user?.MemberLastName}`;
});

export const getUserId = createSelector(getUser, getLoadingState, (user, loading) => {
  if (loading) return null;
  return user?.UniqueID;
});

export const getUserMlsId = createSelector(getUser, getLoadingState, (user, loading) => {
  if (loading) return null;
  return user?.MemberMlsId;
});

export const getUserAvatar = createSelector(({ user }) => user.userPhoto, getLoadingState, (photo, loading) => {
  if (loading) return null;
  const [preferredImage] = photo?.filter(p => p?.PreferredPhotoYN) ?? [];
  if (!preferredImage) return photoPlaceholder;
  return getImage(preferredImage?.URL);
});

export const getUserIdleStatus = createSelector(({ user }) => user.isIdle, result => result);
